import React, { FC, useContext } from 'react';

import NewsGridTag from 'common/NewsGrid/NewsGridTags/NewsGridTag';
import { hexToRgb } from 'utils/colorsHandler';
import { formatDisplayDate } from 'utils/dateHandler';

import ScreenRecognitionContext from '../../../contexts/screenRecognitionContext';
import { NewsListInformationWithTagsProps } from './models';

import './NewsListInformationWithTags.scss';

const NewsListInformationWithTags: FC<NewsListInformationWithTagsProps> = ({
  tagName,
  creationDate,
  articleTypeColor,
  readingTime,
  readingTimeText,
  articleTags,
  lang,
}) => {
  const { isMobile, isSmallMobile } = useContext(ScreenRecognitionContext);

  return (
    <div className="article__information-wrap">
      <div className="article__type-time">
        {tagName ? (
          <span
            className="article__type tag"
            style={{ backgroundColor: `rgba(${hexToRgb(articleTypeColor)}, 0.2)` }}
          >
            {tagName}
          </span>
        ) : null}
        {!isSmallMobile && !isMobile ? (
          <div className="article__tags article__tags--margin">
            {articleTags?.map((tag) => (
              <NewsGridTag tagName={tag.name} key={tag.name} />
            ))}
          </div>
        ) : null}
        <span className="article__time tag">{formatDisplayDate(creationDate, lang)}</span>
      </div>
      <div className="article__read-views">
        <span className="article__read tag">{`${readingTime} ${readingTimeText}`}</span>
      </div>
    </div>
  );
};

export default NewsListInformationWithTags;
